export const GET_MERCHANT_TYPE_LIST_ERROR = "GET_MERCHANT_TYPE_LIST_ERROR";
export const GET_MERCHANT_TYPE_LIST_START = "GET_MERCHANT_TYPE_LIST_START";
export const GET_MERCHANT_TYPE_LIST_SUCCESS = "GET_MERCHANT_TYPE_LIST_SUCCESS";